import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { products, productCategories } from '../data/products';
import { images } from '../data/images';
type Filter = 'Alles' | (typeof productCategories)[number];
export function Products() {
  const [filter, setFilter] = useState<Filter>('Alles');
  const [open, setOpen] = useState<string | null>('Savon Beldi');
  const visible = filter === 'Alles' ? products : products.filter(p => p.category === filter);
  const filters: Filter[] = ['Alles', ...productCategories];
  return <section id="producten" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32" data-id="element-65" data-mp="388x9p53gdl2r">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-66" data-mp="3484zo9mrbc5f">
        <div className="lg:col-span-4" data-id="element-67" data-mp="349ogq2g8lr89">
          <div className="lg:sticky lg:top-24" data-id="element-68" data-mp="16hu1snky6klw">
            <h2 className="font-display text-5xl font-medium leading-tight text-ink sm:text-6xl" data-id="element-69" data-mp="16hka8vk985e3">De collectie</h2>
            <p className="mt-6 leading-relaxed text-muted" data-id="element-70" data-mp="12ee3lmt8cc73">
              Zestien pure producten. Per product: wat het is, en hoe je het gebruikt.
            </p>
            <img src={images.products} alt="Arganolie, ghassoul, zwarte zeep, een kessa en rozenblaadjes" className="mt-10 hidden aspect-square w-full rounded-2xl object-cover lg:block" data-id="element-71" data-mp="1dwe1s53pddvk" />
          </div>
        </div>

        <div className="lg:col-span-8" data-id="element-72" data-mp="1rn103w5jx1r4">
          <div role="tablist" aria-label="Categorie" className="flex flex-wrap gap-2" data-id="element-73" data-mp="1rnavjz9d8147">
            {filters.map(f => {
            const active = f === filter;
            return <button key={f} role="tab" aria-selected={active} onClick={() => setFilter(f)} className={`whitespace-nowrap rounded-full border px-4 py-1.5 text-sm transition-colors duration-150 ${active ? 'border-ink bg-ink text-sand' : 'border-hairline text-muted hover:border-ink hover:text-ink'}`} data-id="element-74" data-mp="1ito1cdkt35x4">
                  {f}
                </button>;
          })}
          </div>

          <ul className="mt-10 border-b border-hairline" data-id="element-75" data-mp="2l4waozdra3xp">
            {visible.map(p => {
            const isOpen = open === p.name;
            const id = `product-${p.name.replace(/\W/g, '')}`;
            return <li key={p.name} className="border-t border-hairline" data-id="element-76" data-mp="269zv213maeal">
                  <button onClick={() => setOpen(isOpen ? null : p.name)} aria-expanded={isOpen} aria-controls={id} className="group grid w-full grid-cols-[1fr_auto] items-center gap-4 py-6 text-left" data-id="element-77" data-mp="26batdleamtub">
                    <span className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:gap-4" data-id="element-78" data-mp="1niyvbauoaepz">
                      <span className="font-display text-3xl text-ink transition-colors duration-150 group-hover:text-clay" data-id="element-79" data-mp="1ijvoplz1o0fw">{p.name}</span>
                      <span className="text-sm text-muted" data-id="element-80" data-mp="18ex6de8b78vq">{p.alias}</span>
                    </span>
                    <span className="flex items-center gap-4" data-id="element-81" data-mp="1de0dr5brhr6v">
                      <span className="hidden text-xs uppercase tracking-wider text-muted md:inline" data-id="element-82" data-mp="1ie4rwop769tx">{p.category}</span>
                      <PlusIcon className={`h-5 w-5 text-ink transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-83" data-mp="1ndhgbdvpvoym" />
                    </span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-84" data-mp="znn4mzn4w6fy">
                    {isOpen && <motion.div id={id} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-85" data-mp="zlk7zwrh7f29">
                        <dl className="grid gap-6 pb-8 sm:grid-cols-2 sm:gap-10" data-id="element-86" data-mp="2dkvmfumgq8cz">
                          <div data-id="element-87" data-mp="28m29q4f02ldv">
                            <dt className="font-display text-lg italic text-clay" data-id="element-88" data-mp="2ncrp7izhumnj">Wat het is</dt>
                            <dd className="mt-1 leading-relaxed text-muted" data-id="element-89" data-mp="2iml25nkmra7e">{p.what}</dd>
                          </div>
                          <div data-id="element-90" data-mp="2wcy7rja1uctk">
                            <dt className="font-display text-lg italic text-clay" data-id="element-91" data-mp="2wc51skiwzrch">Hoe je het gebruikt</dt>
                            <dd className="mt-1 leading-relaxed text-muted" data-id="element-92" data-mp="2sbuv15naswwk">{p.use}</dd>
                          </div>
                        </dl>
                      </motion.div>}
                  </AnimatePresence>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}